import { NgModule } from '@angular/core';

import { HijriGregorianDatepickerComponent } from './hijri-gregorian-datepicker.component';
import { HijriDatepickerComponent } from './hijri-datepicker/hijri-datepicker.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateFormatterService } from './date-formatter.service';
import { CustomNgbDateParserFormatter } from './CustomNgbDateParserFormatter';
import { ProvideParentFormDirective } from './provide-parent-form.directive';

@NgModule({
  declarations: [
 
    HijriGregorianDatepickerComponent,
    HijriDatepickerComponent,
    ProvideParentFormDirective
  ],
  imports: [
    CommonModule ,
    ReactiveFormsModule,
    FormsModule,
    NgbModule
  ],
  providers: [
    {provide: NgbDateParserFormatter, useClass: CustomNgbDateParserFormatter},
    DateFormatterService
  ],
  exports: [ HijriGregorianDatepickerComponent ]
})
export class NgxHijriGregorianDatepickerModule { }
